import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.RECOVER_PASSWORD_PAGE]: {
    [ROLE.FORM]: [ELEMENT.RECOVER],
    [ROLE.BUTTON]: [ELEMENT.GO_BACK],
    [ROLE.CONTAINER]: [ELEMENT.SUCCESS_FEEDBACK],
  },
} as TValidTestId;
